import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

/**
 * Нужен ли служебный алерт над текстом отзыва.
 *
 * Кроме скрытия / удаления / аннуляции сюда входит отзыв без профиля пациента:
 * он не участвует в рейтинге, и это нужно показать явно.
 */
export function hasReviewAlert(rate: Rate): boolean {
  return Boolean(
    rate.is_hidden_for_verification
    || rate.is_deleted
    || rate.is_refuted
    || !rate.patient_profile_id,
  )
}

/**
 * Статус расширенной проверки документов.
 *
 * В SSR это может быть и массив, и объект с `first` / `all` —
 * без нормализации текст алерта не соберётся.
 */
export function getHiddenVerificationStatus(rate: Rate): string | undefined {
  const { documents_statuses: statuses } = rate

  if (!statuses) {
    return undefined
  }

  if (Array.isArray(statuses)) {
    return statuses[0]?.status
  }

  return statuses.first?.status || statuses.all?.[0]?.status
}
